import ToastComponent from '@/components/toast/toast.vue'

const Toast = {}

// 注册Toast
Toast.install = function(Vue) {
  // 生成一个Vue的子类
  // 同时这个子类也就是组件
  const ToastConstructor = Vue.extend(ToastComponent)
  // 生成一个该子类的实例
  const instance = new ToastConstructor()

  // 将这个实例挂载在我创建的div上
  // 并将此div加入全局挂载点内部
  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)

  // 通过Vue的原型注册一个方法
  // 让所有实例共享这个方法
  /*
   * msg 消息内容
   * msgType 消息类型
   * duration 多少时间后消失 */
  Vue.prototype.$msg = (msg, msgType = 'info', duration = 3000) => {
    msgType = msgType ? msgType : 'info'
    duration = duration ? duration : 3000
    instance.message = msg
    instance.visible = true
    instance.msgType = msgType
    // if(typeof(msgType) != 'undefined' && msgType.length > 0) {
    //     instance.msgType = msgType;
    // }
    // if(typeof(duration) == 'undefined') {
    //     duration = 5000
    // }
    console.log('duration=' + duration)
    console.log('duration=' + msgType)
    setTimeout(() => {
      instance.visible = false
    }, duration)
  }
}

export default Toast



// WEBPACK FOOTER //
// ./src/api/toast.js